import $ from 'jquery'
import 'semantic-ui-css/components/input.min.css'
import './modules/semantic-ui-form'
import { trans, PLEASE_ENTER_EMAIL, PLEASE_ENTER_VALID_EMAIL } from '../../translator'

$('document').ready(function () {
  const $form = $('form')
  const $emailInput = $form.find('input[type="email"]')
  const emailIdentifier = $emailInput.attr('id') || $emailInput.attr('name')

  if (!emailIdentifier) {
    return
  }

  $form.form({
    fields: {
      [emailIdentifier]: {
        identifier: emailIdentifier,
        rules: [
          {
            type: 'empty',
            prompt: trans(PLEASE_ENTER_EMAIL, {}, 'users')
          },
          {
            type: 'symfonyHtml5Email',
            prompt: trans(PLEASE_ENTER_VALID_EMAIL, {}, 'users')
          }
        ]
      }
    },
    inline: true
  })
})
